import React, {ReactNode} from "react";
import {withTranslation} from "react-i18next";
import {withHostApi} from "../../contexts/HostApiContext";


interface SelectTextileColorProps {
  showWhiteTransferModale: (show:boolean) => void;
  typeTransfer: string;
  t: (arg0: string) => ReactNode;
  hostApi: string
}


interface SelectTextileColorState {
  textile: number
}

class SelectTextileColor extends React.Component<SelectTextileColorProps, SelectTextileColorState> {
  constructor(props: SelectTextileColorProps) {
    super(props);
    this.state = {
      textile: this.props.typeTransfer === 'w' ? 1 : 0
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  private handleSelect(event: React.ChangeEvent<HTMLSelectElement>) {
    if(parseInt(event.target.value,10) === 1 || this.props.typeTransfer === 'w' && (parseInt(event.target.value,10) === 0) ) {
      this.props.showWhiteTransferModale(true);
    } else {
      this.setState({
        textile: this.props.typeTransfer === 'w' ? 1 : 0
      })
    }
  }

  render() {

    return (
        <div>
          <select className="w100 py-2 px-1" value={this.state.textile} onChange={this.handleSelect}>
            <option key={0} value={0}>
              {this.props.t('colored_fabric')}
            </option>
            <option key={1} value={1}>
              {this.props.t('white_fabric')}
            </option>
          </select>
        </div>
    );
  }
}
export default withTranslation('common')(withHostApi(SelectTextileColor));
